/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
export { CashWorkspaceScreen as CashManagementScreen } from './workspace/CashWorkspaceScreen';
